<template>
  <div data-app>
    <md-dialog :md-active.sync="showXeroDialog">
      <md-dialog-content>
        <group-card title="Add New Contact">
          <div class="md-layout input-layout">
            <div class="boxed-category md-layout input-layout">
              <validated-text-input class="md-layout-item md-small-size-100 md-size-100"
                                      v-model="newContactName" label="Lender Name"/>
              <notification-card
              icon="info"
              class="md-layout-item md-small-size-100 md-size-100"
              type="warning"
              message="Please make sure the contacts are up to date with Xero. Use accounting page to sync the latest data."
              ></notification-card>
              <search-text-input class="md-layout-item md-size-100"
                                 label="Xero Contact Name"
                                 v-model="selectedNewXero"
                                 :searcher="searchXeroContacts"
                                 min-length="2"
                                 @select="selectNewXeroContact"
                                 clearable
              >
                <template v-slot="{ item }">
                  {{ item.name }}
                </template>
              </search-text-input>
              <md-card-actions>
                <loading-icon-text-button icon="link" @click="saveNewLenderXeroContact">Add & Link</loading-icon-text-button>
              </md-card-actions>
            </div>
          </div>
        </group-card>
      </md-dialog-content>
    </md-dialog>
    <group-card title="Lender Details" icon="info" padded>
      <template slot="actions">
        <loading-icon-text-button icon="contacts" @click="showXeroDialog=true">Add New Contact</loading-icon-text-button>
        <loading-icon-text-button icon="save" @click="save">Save</loading-icon-text-button>
      </template>

      <md-card-content>
        <group-card icon="contacts" padded title="Basic">
          <div class="md-layout input-layout">
            <validated-text-input label="Lender Name" v-model="lender.lender_name"
                                  class="md-layout-item md-small-size-15 md-size-15" required></validated-text-input>
            <validated-number-input label="ADP Lender ID" v-model="lender.adp_lender_id"
                                    class="md-layout-item md-small-size-15 md-size-15"></validated-number-input>
            <validated-select-input label="Product Type" required :options="['loan','lease']"
                                    v-model="lender.product_type"
                                    class="md-layout-item md-small-size-15 md-size-15"></validated-select-input>
            <validated-select-input label="Application Type" required :options="['commercial','consumer']"
                                    v-model="lender.application_type"
                                    class="md-layout-item md-small-size-15 md-size-15"></validated-select-input>
            <validated-select-input label="Asset Type" required :options="['personal','vehicle']"
                                    v-model="lender.asset_type"
                                    class="md-layout-item md-small-size-15 md-size-15"></validated-select-input>
            <validated-text-input label="Submission API" v-model="lender.submission_api"
                                  class="md-layout-item md-small-size-20 md-size-20"></validated-text-input>
          </div>
        </group-card>

        <group-card icon="inventory_2" padded title="Pod Settings">
          <div class="md-layout input-layout">
            <div class="md-layout-item md-small-size-100 md-size-9">
              <label>Pod Allows in Reporting: {{ lender.pod_applied }}</label>
              <v-autocomplete
                v-model="lender.pods"
                :items="getPods"
                dense
                chips
                filled
                small-chips
                multiple
                item-value="id"
                item-text="description"
                label="Pods"
                ref="pods"
                @blur="blurDropdown('pods')"
                >
              <template v-slot:prepend-item>
                  <v-list-item
                    ripple
                    @mousedown.prevent
                    @click="toggle('pods')"
                  >
                  </v-list-item>
                </template>
              </v-autocomplete>
            </div>
          </div>
        </group-card>

        <group-card icon="conveyor_belt" padded title="Products">
          <template slot="actions">
            <loading-icon-text-button icon="add" @click="addNewProduct">Add New</loading-icon-text-button>
          </template>
          <md-card-content>
            <div v-for="(product,index) in products">
              <group-card :title="'Product '+ (index+1)">
                <template slot="actions">
                  <md-button class="md-just-icon md-primary md-simple"
                             @click="removeProduct(product)">
                    <md-icon>close</md-icon>
                  </md-button>
                </template>
                <div class="md-layout input-layout">
                  <validated-number-input label="ADP Product ID" v-model="product.adp_product_id"
                                          class="md-layout-item md-small-size-15 md-size-15"></validated-number-input>
                  <validated-text-input label="Product Name" v-model="product.product_name"
                                        class="md-layout-item md-small-size-15 md-size-15"
                                        required></validated-text-input>
                  <validated-text-input label="Submission Email" class="md-layout-item md-small-size-20 md-size-20"
                                        v-model="product.submission_email" melissaCheckType="email"/>
                  <validated-text-input label="Submission API" v-model="product.submission_api"
                                        class="md-layout-item md-small-size-20 md-size-20"></validated-text-input>
                  <validated-text-input label="Submission URL" v-model="product.submission_url"
                                        class="md-layout-item md-small-size-20 md-size-20"></validated-text-input>
                  <validated-text-input label="Broker Fee" v-model="product.broker_fee"
                                        class="md-layout-item md-small-size-20 md-size-20"></validated-text-input>
                  <validated-text-input label="Commission Percentage" v-model="product.default_comission_percentage"
                                        class="md-layout-item md-small-size-20 md-size-20"></validated-text-input>
                  <validated-text-input label="Commission Amount" v-model="product.default_comission_amount"
                                        class="md-layout-item md-small-size-20 md-size-20"></validated-text-input>
                  <validated-select-input class="md-layout-item md-small-size-15 md-size-15"
                                          label="Xero Contact"
                                          v-model="product.lender_xero_contact_id"
                                          :options="existingContacts">
                  </validated-select-input>
                </div>
              </group-card>
            </div>
          </md-card-content>
        </group-card>
        <group-card
          v-if="lender.id"
          title="Client Credentials"
          icon="vpn_key"
          padded
        >
          <!-- Client Secret Display -->
          <md-dialog :md-active.sync="client_secret_dialog">
            <md-dialog-title>Secret Key</md-dialog-title>

            <md-dialog-content>
              <br />
              <p class="md-caption">Secret Key:</p>
              <pre class="md-title">{{ client_credentials.client_secret }}</pre>
              <br />
              <p>
                Please note down the client secret, it can only be viewed once!
              </p>
            </md-dialog-content>

            <md-dialog-actions>
              <md-checkbox v-model="client_credentials.client_secret_seen"
                >Client secret written down</md-checkbox
              >
              <loading-icon-text-button icon="content_copy" :disabled="disabled" @click="copySecret(client_credentials.client_secret)" class="material-icons md-primary md-simple">Copy</loading-icon-text-button>
              <md-button
                class="md-primary md-simple"
                @click="onCreateClientSecretClose"
                :disabled="!client_credentials.client_secret_seen"
                >Close</md-button
              >
            </md-dialog-actions>
          </md-dialog>
          <template slot="actions">
            <loading-icon-text-button
              icon="add"
              @click="generateCredential(client_credentials.client_id)"
              >Generate New Credentials</loading-icon-text-button
            >
          </template>
          <div
            v-if="client_credentials.client_id"
            class="md-layout boxed-category"
            padded
          >
            <validated-text-input
              label="Client Id"
              class="md-layout-item md-small-size-50 md-size-50"
              v-model="client_credentials.client_id"
              disabled
            />
            <validated-text-input
              label="Client Secret"
              class="md-layout-item md-small-size-50 md-size-50"
              :value="'secret'"
              :type="'password'"
              disabled
            />
          </div>
        </group-card>
      </md-card-content>
      <md-card-actions>
        <md-button class="md-primary"
                   @click="save">
          <md-icon>save</md-icon>
          Save
        </md-button>
      </md-card-actions>
    </group-card>
  </div>
</template>
<script>
import {GroupCard} from "@/components";
import {newLender, newProduct} from "@/schema.js";
import {mapGetters} from "vuex";
import ValidatedInputs from '@/components/ValidatedInput';
import ValidatedTextInput from "../components/ValidatedInput/ValidatedTextInput";
import ValidatedSelectInput from "../components/ValidatedInput/ValidatedSelectInput";
import ValidatedNumberInput from "../components/ValidatedInput/ValidatedNumberInput";
import LoadingIconTextButton from "../components/LoadingIconTextButton";
import ValidatedEmailInput from "../components/ValidatedInput/ValidatedEmailInput";
import ConfirmDialog from "../components/Dialogs/ConfirmDialog";
import NotificationCard from "../components/Cards/NotificationCard";
import WaitingDialog from "../components/Dialogs/WaitingDialog";

export default {
  components: {
    NotificationCard,
    ValidatedEmailInput,
    LoadingIconTextButton,
    ValidatedNumberInput,
    ValidatedSelectInput,
    ValidatedTextInput,
    GroupCard,
    ...ValidatedInputs,
  },
  data() {
    return {
      lender: newLender(),
      products: [newProduct()],
      showXeroDialog: false,
      existingContacts: [],
      selectedExistingXero: null,
      selectedNewXero: null,
      selectedNewXeroId: null,
      newContactName: null,
      client_secret_dialog: false,
      disabled: false,
      client_credentials: {
        client_id: null,
        client_secret_seen: false,
        client_secret: '',
      },
    }
  },
  computed: {
    ...mapGetters([
      "options"
    ]),
    getPods() {
      return this.$store.state.administration_pods ?? [];
    }
  },
  methods: {
    addNewProduct() {
      this.products.push(newProduct());
    },
    async copySecret(secret) {
      await navigator.clipboard.writeText(secret);
      this.disabled = true;
      setTimeout(() => {
          this.disabled = false;
        }, 2000)
    },
    async generateCredential(){
      try {
        let { data: client_credentials } = await axios.post('/api/v1/administration/lender/add-client', {
        client_id: this.client_credentials.client_id,
        lender_id: this.lender.id
        });
      this.client_credentials.client_id = client_credentials.client_id;
      this.client_credentials.client_secret = client_credentials.client_secret;
      this.client_secret_dialog = true;
      } catch (error) {
        const errors = error.response.data.errors;
        let error_messages = [];
        if (errors) {
          if (typeof errors == "object") {
            for (const key in errors) {
              if (Array.isArray(errors[key])) {
                errors[key].forEach((errMsg) => error_messages.push(errMsg));
              }
            }
          } else if (typeof errors == "string") {
            error_messages.push(errors);
          }
          this.$modal.show(AlertDialog, {
            title: "Failed to generate new credentials.",
            message: error_messages.join(""),
          });
        }
      }
    },
    onCreateClientSecretClose(){
      this.client_secret_dialog = false;
      this.client_credentials.client_secret = null;
      this.client_credentials.client_secret_seen = false;
    },
    async removeProduct(product) {
      //if there is a product id then show alert and remove from array
      //else remove the product from the array
      if (product.id) {
        if (await this.showAlertDialog('Remove Product?', 'Are you sure you want to remove this product?')) {
          await this.delete(product);
          this.products.splice(this.products.indexOf(product), 1);
        }
      } else {
        this.products.splice(this.products.indexOf(product), 1);
      }
    },
    async showAlertDialog(title, message) {
      return await this.$modal.show(ConfirmDialog, {
        title: title,
        message: message,
        confirmText: "Delete",
        cancelText: 'Close',
      });
    },
    blurDropdown(event) {
      this.$refs[event].isMenuActive = false;
      this.isActiveChips = false;
    },
    async save() {
      this.showLoadingDialog('Saving', 'Please wait whilst the lender detail is being saved.');

      // very new lender doesn't have a product child that is why doesn't go to the table
      if (!this.lender.hasOwnProperty('products')) {
        this.lender['products'] = this.products;
      }

      await axios.post('/api/v1/administration/lender/save', {
        lender: this.lender,
      });
      // after saving a new lender redirection to the list of lenders
      const lenderId = this.$route.params.lender_id;
      if (lenderId && lenderId == 'new') {
        this.$router.push('/administration/lenders');
      }

      await this.getExisting();

      if (this.$modal.submit) {
        this.$modal.submit();
      }
    },
    async delete(product) {
      if (product.id) {
        await axios.get(`/api/v1/administration/lender_product/${product.id}/delete`);
      }
    },
    async getExisting() {
      const lenderId = this.$route.params.lender_id;
      if (lenderId && lenderId != 'new') {
        let response = await axios.get(`/api/v1/administration/lender/${lenderId}/view`);
        this.lender = response.data;
        this.products = response.data.products;
        this.client_credentials.client_id = response?.data?.client_credentials?.client_id ? response.data.client_credentials.client_id : null;
      }
      await this.getXeroOptions();
      await this.$store.dispatch('fetch_administration_user_pods', true);
      this.$store.state.administration_pods.unshift("All");
    },
    async getXeroOptions()
    {
      await axios.get('/api/v1/administration/getLenderXeroContact').then(response => {
        this.existingContacts = response.data;
      });
    },
    async searchXeroContacts(query) {
      if (query.length > 2) {
        let { data } = await this.$store.dispatch('get_xero_contacts', query);
        return data;
      }
    },
    showLoadingDialog(title, message) {
      this.$modal.show(WaitingDialog, {
        title: title,
        message: message,
      });
    },
    async saveNewLenderXeroContact()
    {
      let response = await axios.post(`/api/v1/administration/lender/saveNewXeroContact`, {id: this.selectedNewXeroId, name: this.newContactName});
      this.selectedExistingXero = response.data.name;
      this.showXeroDialog = false;
      await this.getXeroOptions();
    },
    selectNewXeroContact(contact)
    {
      this.selectedNewXeroId = contact.id;
      this.selectedNewXero = contact.name;
    }
  },
  mounted() {
    this.getExisting();
  }
}
</script>
